export default __webpack_public_path__ + "static/media/LoginImage.dae2feda.svg";